export default {
  SET_STOCKS (state, stocks) {
    state.stocks = stocks
  },
  SET_POPULARITY (state, popularity) {
    state.popularity = popularity
  },
  SET_STOCK (state, stock) {
    state.stock = stock
  },
  SET_STOCKBYCATEGORY(state, stock_category)
  {
    state.stock_category = stock_category
  },
  SET_STOCK_QUOTATION (state, stock) {
    state.stock_quotation = stock
  },
  SET_STOCK_OPERATION_LIST (state, stock_operationlist) {
    state.stock_operationlist = stock_operationlist
  }
}
